var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobotSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7A872"
    },
    cx: 256.208,
    cy: 30.844,
    r: 22.45
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E88158"
    },
    d: "M305.292,155.633c0-27.106-21.974-49.08-49.08-49.08s-49.08,21.974-49.08,49.08"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D37250"
    },
    d: "M256.212,106.553c-9.947,0-17.996,21.977-17.996,49.08h-31.084 C207.132,128.529,229.098,106.553,256.212,106.553z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M366.394,155.633H146.03c-26.49,0-47.964,21.474-47.964,47.964v128.749 c0,26.49,21.474,47.964,47.964,47.964h220.365c26.49,0,47.964-21.474,47.964-47.964V203.597 C414.358,177.107,392.884,155.633,366.394,155.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M414.358,504.035v-37.637c0-26.49-21.474-47.964-47.964-47.964H146.03 c-26.49,0-47.964,21.474-47.964,47.964v37.637"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M186.922,380.308h-40.889c-26.492,0-47.967-21.475-47.967-47.967V203.599 c0-26.492,21.475-47.967,47.967-47.967h40.889c-26.481,0-47.956,21.475-47.956,47.967v128.742 C138.966,358.834,160.441,380.308,186.922,380.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M186.922,418.438c-26.481,0-47.956,21.475-47.956,47.956v37.639h-40.9v-37.639 c0-26.481,21.475-47.956,47.967-47.956H186.922z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.029,
    y: 380.314,
    style: {
      fill: "#CCCCCC"
    },
    width: 220.368,
    height: 38.125
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A872"
    },
    d: "M298.032,308.326h-83.641c-17.261,0-31.254,13.993-31.254,31.254v40.73h146.149v-40.73 C329.286,322.319,315.293,308.326,298.032,308.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09461"
    },
    d: "M298.032,308.326h-83.641c-17.261,0-31.254,13.993-31.254,31.254v21.813 c0-17.261,13.993-31.254,31.254-31.254h83.641c17.261,0,31.254,13.993,31.254,31.254V339.58 C329.286,322.319,315.293,308.326,298.032,308.326z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DDA758"
    },
    cx: 347.136,
    cy: 249.434,
    r: 31.629
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDA758"
    },
    d: "M196.916,249.43c0,3.741-0.643,7.318-1.843,10.645c-4.363,12.237-16.055,20.984-29.786,20.984 c-13.731,0-25.423-8.747-29.786-20.984c-1.2-3.327-1.843-6.904-1.843-10.645c0-17.472,14.157-31.629,31.629-31.629 S196.916,231.957,196.916,249.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4BD64"
    },
    d: "M195.073,260.075c-4.363,12.237-16.055,20.984-29.786,20.984c-13.731,0-25.423-8.747-29.786-20.984 c4.363-12.237,16.044-20.995,29.786-20.995C179.029,239.079,190.71,247.837,195.073,260.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4BD64"
    },
    d: "M376.923,260.075c-4.363,12.237-16.055,20.984-29.786,20.984s-25.423-8.747-29.786-20.984 c4.363-12.237,16.044-20.995,29.786-20.995S372.561,247.837,376.923,260.075z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.146,225.211c4.519,0,8.18-3.662,8.18-8.18v-13.647c0-30.957-25.186-56.144-56.144-56.144H215.924 c3.8-18.646,20.324-32.72,40.076-32.72c14.746,0,28.408,7.99,35.658,20.851c2.217,3.936,7.206,5.326,11.142,3.109 c3.935-2.218,5.328-7.207,3.109-11.142c-8.787-15.591-24.316-26.059-41.73-28.582V60.141c12.929-3.588,22.45-15.456,22.45-29.511 c0-16.889-13.74-30.63-30.63-30.63c-16.89,0-30.63,13.741-30.63,30.63c0,14.056,9.52,25.923,22.45,29.511v38.612 c-25.037,3.598-44.888,23.448-48.486,48.486h-53.517c-30.958,0-56.144,25.186-56.144,56.144v128.749 c0,28.179,20.87,51.569,47.964,55.541v22.97c-27.094,3.973-47.964,27.361-47.964,55.541v37.637c0,4.518,3.661,8.18,8.18,8.18 c4.519,0,8.18-3.662,8.18-8.18v-37.637c0-21.936,17.846-39.784,39.784-39.784h162.537c4.519,0,8.18-3.662,8.18-8.18 s-3.661-8.18-8.18-8.18H153.999v-21.765h204.005v21.765h-22.381c-4.519,0-8.18,3.662-8.18,8.18s3.661,8.18,8.18,8.18h30.561 c21.936,0,39.784,17.846,39.784,39.784v37.637c0,4.518,3.661,8.18,8.18,8.18s8.18-3.662,8.18-8.18v-37.637 c0-28.179-20.87-51.569-47.964-55.541v-22.97c27.094-3.973,47.964-27.363,47.964-55.541v-87.835c0-4.518-3.661-8.18-8.18-8.18 s-8.18,3.662-8.18,8.18v87.835c0,21.936-17.846,39.784-39.784,39.784h-28.929v-32.55c0-21.745-17.691-39.435-39.434-39.435H214.18 c-21.745,0-39.434,17.691-39.434,39.434v32.55h-28.928c-21.936,0-39.784-17.846-39.784-39.784V203.383 c0-21.936,17.846-39.784,39.784-39.784h220.365c21.936,0,39.784,17.846,39.784,39.784v13.647 C405.966,221.548,409.629,225.211,414.146,225.211z M241.73,30.63c0-7.868,6.401-14.27,14.27-14.27c7.869,0,14.27,6.402,14.27,14.27 s-6.401,14.269-14.27,14.269C248.131,44.899,241.73,38.498,241.73,30.63z M222.36,316.292h25.46v55.624h-25.46V316.292z  M320.895,339.366v32.55h-14.894V350.09c0-4.518-3.661-8.18-8.18-8.18s-8.18,3.662-8.18,8.18v21.825h-25.46v-55.624h25.46v11.985 c0,4.518,3.661,8.18,8.18,8.18s8.18-3.662,8.18-8.18v-10.461C314.692,321.129,320.895,329.526,320.895,339.366z M191.106,339.366 c0-9.84,6.203-18.238,14.894-21.549v54.099h-14.894V339.366z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M307.117,249.216c0,21.951,17.858,39.809,39.809,39.809s39.809-17.858,39.809-39.809s-17.858-39.809-39.809-39.809 S307.117,227.265,307.117,249.216z M370.375,249.216c0,12.93-10.519,23.449-23.449,23.449s-23.449-10.519-23.449-23.449 c0-12.93,10.519-23.449,23.449-23.449S370.375,236.286,370.375,249.216z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.266,249.216c0,21.951,17.858,39.809,39.809,39.809s39.809-17.858,39.809-39.809s-17.858-39.809-39.809-39.809 S125.266,227.265,125.266,249.216z M188.525,249.216c0,12.93-10.519,23.449-23.449,23.449s-23.449-10.519-23.449-23.449 c0-12.93,10.519-23.449,23.449-23.449S188.525,236.286,188.525,249.216z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.833,447.653h-5.725c-4.519,0-8.18,3.662-8.18,8.18s3.661,8.18,8.18,8.18h5.725c4.519,0,8.18-3.662,8.18-8.18 S207.352,447.653,202.833,447.653z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.757,464.013h21.538c4.519,0,8.18-3.662,8.18-8.18s-3.661-8.18-8.18-8.18h-21.538c-4.519,0-8.18,3.662-8.18,8.18 S149.239,464.013,153.757,464.013z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.833,473.827h-49.076c-4.519,0-8.18,3.662-8.18,8.18s3.661,8.18,8.18,8.18h49.076c4.519,0,8.18-3.662,8.18-8.18 S207.352,473.827,202.833,473.827z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M358.245,447.653h-49.078c-4.519,0-8.18,3.662-8.18,8.18s3.661,8.18,8.18,8.18h49.078c4.519,0,8.18-3.662,8.18-8.18 S362.763,447.653,358.245,447.653z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M358.245,473.827h-49.078c-4.519,0-8.18,3.662-8.18,8.18s3.661,8.18,8.18,8.18h49.078c4.519,0,8.18-3.662,8.18-8.18 S362.763,473.827,358.245,473.827z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotSvgrepoCom);
export default __webpack_public_path__ + "static/media/robot-svgrepo-com.6d48eac7b6dff8a6c2fa232bceb32a71.svg";
export { ForwardRef as ReactComponent };